import { FrameItem, Icon, MapCustomForAction } from 'components';
import { CoordinateModel, StageActionItem } from 'models';
import { useEffect, useState } from 'react';
import { handleGetPlace } from 'utils';
import './StageActionDetailMap.scss';

type StageActionDetailMapProps = {
    data: StageActionItem;
};

const StageActionDetailMap = ({ data }: StageActionDetailMapProps): JSX.Element => {
    const [location, setLocation] = useState<CoordinateModel>({ coordinates: { lat: 0, lng: 0 }, description: '' });

    const handleGetLocation = async (latitude, longitude): Promise<void> => {
        if (latitude && longitude) {
            const res: any = await handleGetPlace(latitude, longitude, false);

            setLocation({ coordinates: { lat: latitude, lng: longitude }, description: res.substring(3) });
        } else {
            // デフォルトで東京駅を設定する
            setLocation({ coordinates: { lat: 35.68177632025714, lng: 139.76714518293858 }, description: '' });
        }
    };

    useEffect(() => {
        // console.log(data?.action_latitude);
        // console.log(data?.action_longitude);
        handleGetLocation(data?.action_latitude, data?.action_longitude);
    }, [data?.action_latitude, data?.action_longitude]);

    return (
        <div className="mt-10">
            <FrameItem
                children={
                    <div className="actiondetail-location">
                        <div className="location-wrapper">
                            <p className="title">
                                <span className="text">位置情報</span>
                            </p>
                            <p className="address">
                                <span className="icon">
                                    <Icon.Coordinate width="14" height="20" />
                                </span>
                                <span className="text"> {location?.description}</span>
                            </p>
                            <div className="map">
                                <MapCustomForAction data={data ? [data] : []} detailAction={true} />
                            </div>
                        </div>
                    </div>
                }
            />
        </div>
    );
};

export default StageActionDetailMap;
